import { Dashboard } from "../containers/Dashboard";
import {
  BuyerType,
  BuyerInvestorType,
  BuyerBudget,
  BuyerLocations,
  BuyerCompleted,
  BuyerInterests,
  BuyerBio,
  BuyerCategory,
} from "../containers/ProfileCompletion/Buyer";
import {
  SellerDetails,
  SellerFunding,
  SellerPostAcquisition,
  SellerKeyAssets,
  SellerLocation,
  SellerCategory,
  SellerFinancials,
  SellerAskingPrice,
  SellerCompleted,
} from "../containers/ProfileCompletion/Seller";
import { Questionnarie, BasicInformation } from "../containers/SignUp";
import { Organisation } from "../containers/SignUp/Organisation";
import { RoutePaths, RouteType } from "./enums";
// import AcUnitIcon from "@mui/icons-material/AcUnit";
import SettingsIcon from "@mui/icons-material/Settings";
import { Messages } from "../containers/Messages";
import { Login } from "../containers/Login";
import { CompanyView } from "../containers/CompanyView";
import { YourAcquisitions } from "../containers/YourAcquisitions";
import { YourListings } from "../containers/YourListings/YourListings";
import { Settings } from "../containers/Settings";
import { RegisterStart } from "../containers/Register";
import { ForgotPassword } from "../containers/Login/ForgotPassword";
import { UserType } from "../../common/types";
import {
  HeartIcon,
  ListIcon,
  MoneyIcon,
  WorkIcon,
} from "../../common/assets/icons";
import { TrolleyIcon } from "../../common/assets/icons/TrolleyIcon";
import { AdvisorIcon } from "../../common/assets/icons/AdvisorIcon";
import { MessageIcon } from "../../common/assets/icons/MessageIcon";
import { DocumentIcon } from "../../common/assets/icons/DocumentIcon";
import { CompletedIcon } from "../../common/assets/icons/CompletedIcon";
import { ResetPassword } from "../containers/Login/ResetPassword";
import { Management } from "../containers/Management";
import { PlansPage } from "../containers/PlansPage";
import { PlansIcon } from "../../common/assets/icons/PlansIcon";
import { Referral } from "../containers/Referral";
import { SellerBasic } from "../containers/ProfileCompletion/Seller/SellerBasic";
import { SellerDataRoom } from "../containers/ProfileCompletion/Seller/SellerDataRoom";
import { TestimonialIcon } from "../../common/assets/icons/TestimonialIcon";

export interface MenuItemsInterface {
  icon?: any;
  label: string;
  path: string;
  type: string;
  target: any;
  hideFrom?: UserType;
  checkUser?: boolean;
  fields?: string[];
}
export interface SideMenuItemsInterface {
  [x: string]: { disableGradient?: boolean; items: MenuItemsInterface[] };
}

export const Menus: SideMenuItemsInterface = {
  [RoutePaths.REGISTER]: {
    disableGradient: false,
    items: [
      {
        label: "Basic Details",
        path: RoutePaths.REGISTER + "/basic",
        type: RouteType.PUBLIC,
        target: RegisterStart,
        checkUser: true,
        fields: ["first_name", "last_name", "phone_number"],
      },
      {
        label: "Client Info",
        path: RoutePaths.REGISTER + "/informations",
        type: RouteType.PUBLIC,
        target: Questionnarie,
        checkUser: true,
        fields: ["buyer_genre"],
      },
      {
        label: "How did you hear about us?",
        path: RoutePaths.REGISTER + "/questionnaire",
        type: RouteType.PUBLIC,
        target: Organisation,
      },
    ],
  },
  [RoutePaths.REGISTER_ACQUIRER]: {
    disableGradient: true,
    items: [
      {
        label: "Buyer Type",
        path: RoutePaths.REGISTER_ACQUIRER + "/specific",
        type: RouteType.PUBLIC,
        target: BuyerType,
        checkUser: true,
        fields: ["buyerFull.role"],
      },
      {
        label: "Category Preferences",
        path: RoutePaths.REGISTER_ACQUIRER + "/categories",
        type: RouteType.PUBLIC,
        target: BuyerCategory,
        checkUser: true,
        fields: ["buyerFull.startup_business_types"],
      },
      {
        label: "Location Preferences",
        path: RoutePaths.REGISTER_ACQUIRER + "/locations",
        type: RouteType.PUBLIC,
        target: BuyerLocations,
        checkUser: true,
        fields: ["buyerFull.buyer_location"],
      },
      {
        label: "Acquisition Budget",
        path: RoutePaths.REGISTER_ACQUIRER + "/budget",
        type: RouteType.PUBLIC,
        target: BuyerBudget,
        checkUser: true,
        fields: [
          "buyerFull.valuation",
          "buyerFull.trailing_profit",
          "buyerFull.trailing_revenue",
          "buyerFull.debt_finance",
        ],
      },
      {
        label: "Short Bio",
        path: RoutePaths.REGISTER_ACQUIRER + "/short-bio",
        type: RouteType.PUBLIC,
        target: BuyerBio,
        checkUser: true,
        fields: ["buyerFull.description"],
      },
      {
        label: "Other Interests (Optional)",
        path: RoutePaths.REGISTER_ACQUIRER + "/interests",
        type: RouteType.PUBLIC,
        target: BuyerInterests,
        checkUser: true,
        fields: ["buyerFull.keywords"],
      },
      {
        label: "Investor Profile",
        path: RoutePaths.REGISTER_ACQUIRER + "/type",
        type: RouteType.PUBLIC,
        target: BuyerInvestorType,
        checkUser: true,
        fields: ["buyerFull.buyer_type"],
      },
      {
        icon: CompletedIcon,
        label: "Completed",
        path: RoutePaths.REGISTER_ACQUIRER + "/completed",
        type: RouteType.PUBLIC,
        target: BuyerCompleted,
      },
    ],
  },
  [RoutePaths.REGISTER_SELLER]: {
    disableGradient: true,
    items: [
      {
        label: "Basic Information",
        path: RoutePaths.REGISTER_SELLER + "/:id/basic",
        type: RouteType.PUBLIC,
        target: SellerBasic,
        checkUser: true,
        fields: ["business_type", "website_url"],
      },
      {
        label: "Category",
        path: RoutePaths.REGISTER_SELLER + "/:id/category",
        type: RouteType.PUBLIC,
        target: SellerCategory,
        checkUser: true,
        fields: ["business_categories"],
      },
      {
        label: "Business model",
        path: RoutePaths.REGISTER_SELLER + "/:id/financials",
        type: RouteType.PUBLIC,
        target: SellerFinancials,
        checkUser: true,
        fields: ["business_models", "annual_profit", "annual_revenue"],
      },
      {
        label: "Region",
        path: RoutePaths.REGISTER_SELLER + "/:id/location",
        type: RouteType.PUBLIC,
        target: SellerLocation,
        checkUser: true,
        fields: ["operating_regions"],
      },
      {
        label: "Post-Acquisition",
        path: RoutePaths.REGISTER_SELLER + "/:id/post-acquisition",
        type: RouteType.PUBLIC,
        target: SellerPostAcquisition,
        checkUser: true,
        fields: [
          "growth_opportunity",
          "founders_post_acquisition",
          "weekly_commitment",
        ],
      },
      {
        label: "Business Information",
        path: RoutePaths.REGISTER_SELLER + "/:id/details",
        type: RouteType.PUBLIC,
        target: SellerDetails,
        checkUser: true,
        fields: [
          "date_founded",
          "startup_team_size",
          "competitors",
          "description",
        ],
      },
      {
        label: "Key Assets",
        path: RoutePaths.REGISTER_SELLER + "/:id/keyassets",
        type: RouteType.PUBLIC,
        target: SellerKeyAssets,
        checkUser: true,
        fields: [
          "key_assets_new",
          "weekly_commitment",
          "founders_post_acquisition",
        ],
      },
      {
        label: "Asking Price",
        path: RoutePaths.REGISTER_SELLER + "/:id/asking-price",
        type: RouteType.PUBLIC,
        target: SellerAskingPrice,
        checkUser: true,
        fields: ["asking_price"],
      },
      {
        label: "Data Room",
        path: RoutePaths.REGISTER_SELLER + "/:id/data-room",
        type: RouteType.PUBLIC,
        target: SellerDataRoom,
        checkUser: true,
        fields: ["files"],
      },
      {
        icon: CompletedIcon,
        label: "Completed",
        path: RoutePaths.REGISTER_SELLER + "/:id/completed",
        type: RouteType.PUBLIC,
        target: SellerCompleted,
      },
    ],
  },
  "/buyer": {
    items: [
      {
        icon: WorkIcon,
        label: "Your Acquisition",
        path: "/your-acquisition",
        type: RouteType.PUBLIC,
        target: YourAcquisitions,
      },
      {
        icon: TrolleyIcon,
        label: "Marketplace",
        path: RoutePaths.DASHBOARD,
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: MessageIcon,
        label: "Messages",
        path: "/messages",
        type: RouteType.PUBLIC,
        target: Messages,
      },
      {
        icon: AdvisorIcon,
        label: "Advisors",
        path: "https://foundy.com/advisory/sellers",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: MessageIcon,
        label: "Private Data Room",
        path: RoutePaths.REGISTER_SELLER + "/funding",
        type: RouteType.PUBLIC,
        target: SellerFunding,
        hideFrom: UserType.Buyer,
      },
      {
        icon: DocumentIcon,
        label: "Doc Templates",
        path: "https://foundy.trumpet.app/pods/63ece8e13bd3e0ac24d8c39a/live",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: HeartIcon,
        label: "Give Feedback",
        path: "intercom",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: SettingsIcon,
        label: "Settings",
        path: RoutePaths.REGISTER_SELLER + "/funding",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: TestimonialIcon,
        label: "Testimonials",
        path: "https://testimonials.foundy.com",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
    ],
  },
  "/company": {
    items: [
      {
        icon: WorkIcon,
        label: "Your Acquisition",
        path: "/your-acquisition",
        type: RouteType.PUBLIC,
        target: YourAcquisitions,
      },
      {
        icon: TrolleyIcon,
        label: "Marketplace",
        path: RoutePaths.DASHBOARD,
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: MessageIcon,
        label: "Messages",
        path: "/messages",
        type: RouteType.PUBLIC,
        target: Messages,
      },
      {
        icon: AdvisorIcon,
        label: "Advisors",
        path: "https://foundy.com/advisory/sellers",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: MessageIcon,
        label: "Private Data Room",
        path: RoutePaths.REGISTER_SELLER + "/funding",
        type: RouteType.PUBLIC,
        target: SellerFunding,
        hideFrom: UserType.Buyer,
      },

      {
        icon: DocumentIcon,
        label: "Doc Templates",
        path: "https://foundy.trumpet.app/pods/63ece8e13bd3e0ac24d8c39a/live",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },

      {
        icon: HeartIcon,
        label: "Give Feedback",
        path: "intercom",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: SettingsIcon,
        label: "Settings",
        path: RoutePaths.REGISTER_SELLER + "/funding",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: TestimonialIcon,
        label: "Testimonials",
        path: "https://testimonials.foundy.com",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
    ],
  },
  [RoutePaths.DASHBOARD]: {
    items: [
      {
        icon: WorkIcon,
        label: "Your Acquisition",
        path: "/your-acquisition",
        type: RouteType.PUBLIC,
        target: YourAcquisitions,
      },
      {
        icon: ListIcon,
        label: "Your Listings",
        path: "/your-listings",
        type: RouteType.PUBLIC,
        target: YourListings,
        hideFrom: UserType.Buyer,
      },
      {
        icon: TrolleyIcon,
        label: "Marketplace",
        path: RoutePaths.DASHBOARD,
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },

      {
        icon: MessageIcon,
        label: "Messages",
        path: "/messages",
        type: RouteType.PUBLIC,
        target: Messages,
      },
      {
        icon: PlansIcon,
        label: "Subscription Plans",
        path: RoutePaths.PLANS,
        type: RouteType.AUTHENTICATED,
        target: PlansPage,
        hideFrom: UserType.Seller,
      },
      {
        icon: DocumentIcon,
        label: "Doc Templates",
        path: "https://foundy.trumpet.app/pods/63ece8e13bd3e0ac24d8c39a/live",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: ListIcon,
        label: "Receive Tailored Deal Flow",
        path: "https://meetings-eu1.hubspot.com/joe-lewin/buysideadvisory",
        type: RouteType.AUTHENTICATED,
        target: SellerFunding,
        hideFrom: UserType.Seller,
      },
      {
        icon: MoneyIcon,
        label: "Refer & earn",
        path: "https://foundy.com/partners/referral",
        type: RouteType.AUTHENTICATED,
        target: SellerFunding,
      },
      {
        icon: SettingsIcon,
        label: "Settings",
        path: RoutePaths.SETTINGS,
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: HeartIcon,
        label: "Give Feedback",
        path: "intercom",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
      {
        icon: AdvisorIcon,
        label: "Access Expert Advisory",
        path: "https://foundy.com/advisory/sellers",
        type: RouteType.PUBLIC,
        target: SellerFunding,
        hideFrom: UserType.Buyer,
      },
      {
        icon: TestimonialIcon,
        label: "Testimonials",
        path: "https://testimonials.foundy.com",
        type: RouteType.PUBLIC,
        target: SellerFunding,
      },
    ],
  },
};

export const routes = [
  {
    title: "Login",
    path: RoutePaths.LOGIN,
    type: RouteType.PUBLIC,
    target: Login,
    menu: undefined,
  },
  {
    title: "Register",
    path: "/register",
    type: RouteType.PUBLIC,
    target: RegisterStart,
    menu: undefined,
  },
  {
    title: "Register",
    path: "/referral",
    type: RouteType.PUBLIC,
    target: Referral,
    menu: undefined,
  },
  {
    title: "Register",
    path: "/register/:id?",
    type: RouteType.PUBLIC,
    target: RegisterStart,
    menu: undefined,
  },
  {
    title: "Forgot Password",
    path: RoutePaths.FORGOT_PASSWORD,
    type: RouteType.PUBLIC,
    target: ForgotPassword,
  },
  {
    title: "Reset your password",
    path: RoutePaths.RESET_PASSWORD,
    type: RouteType.PUBLIC,
    target: ResetPassword,
  },
  {
    title: "Management",
    path: "/management",
    type: RouteType.AUTHENTICATED,
    target: Management,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Plans",
    path: "/plans",
    type: RouteType.AUTHENTICATED,
    target: PlansPage,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Register - Basic Details",
    path: RoutePaths.REGISTER + "/basic",
    type: RouteType.PUBLIC,
    target: BasicInformation,
    menu: Menus[RoutePaths.REGISTER],
    exact: true,
  },
  {
    title: "Register - Questions",
    path: RoutePaths.REGISTER + "/informations",
    type: RouteType.PUBLIC,
    target: Questionnarie,
    menu: Menus[RoutePaths.REGISTER],
    exact: true,
  },
  {
    title: "Register - Organisation",
    path: RoutePaths.REGISTER + "/questionnaire",
    type: RouteType.PUBLIC,
    target: Organisation,
    menu: Menus[RoutePaths.REGISTER],
    exact: true,
  },
  ...Menus[RoutePaths.REGISTER_ACQUIRER].items.map(
    ({ label, icon, ...rest }) => ({
      ...rest,
      title: label,
      menu: Menus[RoutePaths.REGISTER_ACQUIRER],
      exact: true,
    })
  ),
  ...Menus[RoutePaths.REGISTER_SELLER].items.map(
    ({ label, icon, ...rest }) => ({
      ...rest,
      title: label,
      menu: Menus[RoutePaths.REGISTER_SELLER],
      exact: true,
    })
  ),
  {
    path: RoutePaths.REGISTER_ACQUIRER + "/completed",
    type: RouteType.PUBLIC,
    target: BuyerCompleted,
    menu: Menus[RoutePaths.REGISTER_ACQUIRER],
    exact: true,
  },
  {
    path: RoutePaths.REGISTER_SELLER + "/completed",
    type: RouteType.PUBLIC,
    target: SellerCompleted,
    menu: Menus[RoutePaths.REGISTER_ACQUIRER],
    exact: true,
  },
  {
    title: "Dashboard",
    path: RoutePaths.DASHBOARD,
    type: RouteType.AUTHENTICATED,
    target: Dashboard,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Settings",
    path: RoutePaths.SETTINGS,
    type: RouteType.AUTHENTICATED,
    target: Settings,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Your Acquisitions",
    path: "/your-acquisition",
    type: RouteType.AUTHENTICATED,
    target: YourAcquisitions,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    icon: ListIcon,
    label: "Your Listings",
    path: "/your-listings",
    type: RouteType.AUTHENTICATED,
    target: YourListings,
    hideFrom: UserType.Buyer,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Messages",
    path: "/messages",
    type: RouteType.AUTHENTICATED,
    target: Messages,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Company View",
    path: "/company/:id",
    type: RouteType.PUBLIC,
    target: CompanyView,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Subscription Plans",
    path: RoutePaths.PLANS,
    type: RouteType.AUTHENTICATED,
    target: PlansPage,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Register - Location",
    path: RoutePaths.REGISTER_SELLER,
    type: RouteType.PUBLIC,
    target: SellerLocation,
    menu: Menus[RoutePaths.DASHBOARD],
  },
  {
    title: "Register - Buyer Type",
    path: RoutePaths.REGISTER_ACQUIRER,
    type: RouteType.PUBLIC,
    target: BuyerType,
    menu: Menus[RoutePaths.DASHBOARD],
  },

  {
    title: "",
    path: "*",
    type: RouteType.PUBLIC,
    target: Login,
    menu: undefined,
  },
];
